// extracted by mini-css-extract-plugin
module.exports = {"datatable":"List_datatable__1Px14","Icons":"List_Icons__1z2Ii"};